// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/partner_register/common/v1/stakeholder.proto

/* oxlint-disable */

/** Stakeholder represents a person associated with an organization during the partner registration process */
export interface ApiStakeholder {
  /** Unique identifier of the stakeholder */
  readonly id: string;
  /** Whether the stakeholder is the organization owner */
  readonly owner?:
    | boolean
    | null
    | undefined;
  /** The phone number of the stakeholder */
  readonly phoneNumber?:
    | string
    | null
    | undefined;
  /** Whether this person is a tax payer in the United States */
  readonly usTaxPayer?:
    | boolean
    | null
    | undefined;
  /** Whether this person is a tax payer in a country different from the legal country of the organization */
  readonly taxPayerOutsideLegalCountry?:
    | boolean
    | null
    | undefined;
  /** Country code where the individual has tax residency outside their business legal country */
  readonly otherTaxResidencyCountry?:
    | string
    | null
    | undefined;
  /** Tax identification number for the foreign country where the individual has tax residency */
  readonly otherTaxIdentificationNumber?:
    | string
    | null
    | undefined;
  /** Whether the individual is considered a US person for tax purposes */
  readonly usPerson?:
    | boolean
    | null
    | undefined;
  /** US Tax Identification Number (TIN) for individuals who are US persons */
  readonly usTaxIdentificationNumber?:
    | string
    | null
    | undefined;
  /** Whether the individual considers themselves a Politically Exposed Person (PEP) */
  readonly selfPepDeclaration?:
    | boolean
    | null
    | undefined;
  /** ID of the organization linked to this stakeholder */
  readonly organizationId: string;
  /** ID of the registration linked to this stakeholder */
  readonly registrationId: string;
  /** Name of the KYC provider for this stakeholder */
  readonly kycProviderName?: string | null | undefined;
}

export const ApiStakeholder: MessageFns<ApiStakeholder> = {
  fromJSON(object: any): ApiStakeholder {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      owner: isSet(object.owner) ? globalThis.Boolean(object.owner) : null,
      phoneNumber: isSet(object.phone_number) ? globalThis.String(object.phone_number) : null,
      usTaxPayer: isSet(object.us_tax_payer) ? globalThis.Boolean(object.us_tax_payer) : null,
      taxPayerOutsideLegalCountry: isSet(object.tax_payer_outside_legal_country)
        ? globalThis.Boolean(object.tax_payer_outside_legal_country)
        : null,
      otherTaxResidencyCountry: isSet(object.other_tax_residency_country)
        ? globalThis.String(object.other_tax_residency_country)
        : null,
      otherTaxIdentificationNumber: isSet(object.other_tax_identification_number)
        ? globalThis.String(object.other_tax_identification_number)
        : null,
      usPerson: isSet(object.us_person) ? globalThis.Boolean(object.us_person) : null,
      usTaxIdentificationNumber: isSet(object.us_tax_identification_number)
        ? globalThis.String(object.us_tax_identification_number)
        : null,
      selfPepDeclaration: isSet(object.self_pep_declaration) ? globalThis.Boolean(object.self_pep_declaration) : null,
      organizationId: isSet(object.organization_id) ? globalThis.String(object.organization_id) : "",
      registrationId: isSet(object.registration_id) ? globalThis.String(object.registration_id) : "",
      kycProviderName: isSet(object.kyc_provider_name) ? globalThis.String(object.kyc_provider_name) : null,
    };
  },

  toJSON(message: ApiStakeholder): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.owner !== undefined && message.owner !== null) {
      obj.owner = message.owner;
    }
    if (message.phoneNumber !== undefined && message.phoneNumber !== null) {
      obj.phone_number = message.phoneNumber;
    }
    if (message.usTaxPayer !== undefined && message.usTaxPayer !== null) {
      obj.us_tax_payer = message.usTaxPayer;
    }
    if (message.taxPayerOutsideLegalCountry !== undefined && message.taxPayerOutsideLegalCountry !== null) {
      obj.tax_payer_outside_legal_country = message.taxPayerOutsideLegalCountry;
    }
    if (message.otherTaxResidencyCountry !== undefined && message.otherTaxResidencyCountry !== null) {
      obj.other_tax_residency_country = message.otherTaxResidencyCountry;
    }
    if (message.otherTaxIdentificationNumber !== undefined && message.otherTaxIdentificationNumber !== null) {
      obj.other_tax_identification_number = message.otherTaxIdentificationNumber;
    }
    if (message.usPerson !== undefined && message.usPerson !== null) {
      obj.us_person = message.usPerson;
    }
    if (message.usTaxIdentificationNumber !== undefined && message.usTaxIdentificationNumber !== null) {
      obj.us_tax_identification_number = message.usTaxIdentificationNumber;
    }
    if (message.selfPepDeclaration !== undefined && message.selfPepDeclaration !== null) {
      obj.self_pep_declaration = message.selfPepDeclaration;
    }
    if (message.organizationId !== undefined && message.organizationId !== null) {
      obj.organization_id = message.organizationId;
    }
    if (message.registrationId !== undefined && message.registrationId !== null) {
      obj.registration_id = message.registrationId;
    }
    if (message.kycProviderName !== undefined && message.kycProviderName !== null) {
      obj.kyc_provider_name = message.kycProviderName;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
